export class StartNotebookSessionInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "engineId",
            "baseName": "engineId",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartNotebookSessionInput.attributeTypeMap;
    }
    constructor() {
    }
}
